(function() {
    "use strict";

    var debug = false;
    function log(text) { if (debug) console.log(text); }

    var initialized = false;
    var shippingMessage = document.createElement("p");
    var shippingZip = document.createElement("input");
    var freteLista = document.createElement("div");

    shippingMessage.classList.add("erros-fretes");
    shippingMessage.setAttribute("style", "display:none");
    freteLista.classList.add("listas-de-fretes");
    freteLista.setAttribute("style", "display:none");

    var initFields = function() {
        if (initialized) return;
        var cartContext = document.querySelector("[data-cart-context=\"true\"]");
        if (!cartContext) { log("Not in cart context"); return; }
        var formularioFrete = cartContext.querySelector(".formulario-frete");
        if (!formularioFrete) { log("Could not find .formulario-frete"); return; }

        shippingZip.type = "text";
        shippingZip.name = "shipping_address[zip]";
        shippingZip.className = "Form__Input cep-calculo-frete form-control";
        shippingZip.placeholder = "DIGITE SEU CEP";
        shippingZip.maxLength = 10;
        shippingZip.addEventListener("input", function(e) {
            var v = e.target.value.replace(/\D/g, "");
            if (v.length > 5) { v = v.substring(0, 5) + "-" + v.substring(5, 8); }
            e.target.value = v;
        });

        var btn = document.createElement("a");
        btn.innerText = "Calcular";
        btn.className = "btn btn-underline button--primary button";
        btn.onclick = function(e) { e.preventDefault(); calculateShipping(); };

        formularioFrete.appendChild(shippingZip);
        formularioFrete.appendChild(btn);

        var wrapper = cartContext.querySelector(".shipping-calc-wrapper");
        if (wrapper) {
            wrapper.appendChild(shippingMessage);
            wrapper.appendChild(freteLista);
        }
        initialized = true;
    };

    var showError = function(msg) {
        freteLista.innerHTML = "";
        freteLista.setAttribute("style", "display:none");
        shippingMessage.innerHTML = msg;
        shippingMessage.setAttribute("style", "display:flex");
    };

    var calculateShipping = function() {
        var cepLimpo = shippingZip.value.replace(/\D/g, "");
        if (cepLimpo.length !== 8) {
            showError("Por favor, digite um CEP válido com 8 dígitos.");
            return;
        }
        shippingMessage.innerHTML = "";
        shippingMessage.setAttribute("style", "display:none");
        freteLista.innerHTML = "<img id=\"loading-icon-frete\" src=\"https://cdn.shopify.com/s/files/1/2184/2809/files/loading-buffering.gif?v=1621716543\" width=\"30\" height=\"30\" alt=\"Carregando...\">";
        freteLista.setAttribute("style", "display:block");

        fetch("https://viacep.com.br/ws/" + cepLimpo + "/json/")
            .then(function(r) { return r.json(); })
            .then(function(dados) {
                if (dados.erro) { showError("CEP não encontrado, tente novamente."); return; }
                var ufMap = {
                    "AC":"Acre","AL":"Alagoas","AP":"Amapa","AM":"Amazonas",
                    "BA":"Bahia","CE":"Ceara","DF":"Distrito Federal","ES":"Espirito Santo",
                    "GO":"Goias","MA":"Maranhao","MT":"Mato Grosso","MS":"Mato Grosso do Sul",
                    "MG":"Minas Gerais","PA":"Para","PB":"Paraiba","PR":"Parana",
                    "PE":"Pernambuco","PI":"Piaui","RJ":"Rio de Janeiro","RN":"Rio Grande do Norte",
                    "RS":"Rio Grande do Sul","RO":"Rondonia","RR":"Roraima","SC":"Santa Catarina",
                    "SP":"Sao Paulo","SE":"Sergipe","TO":"Tocantins"
                };
                var province = ufMap[dados.uf] || dados.uf;
                var params = new URLSearchParams({
                    "shipping_address[country]": "Brazil",
                    "shipping_address[province]": province,
                    "shipping_address[zip]": cepLimpo
                });
                fetch("/cart/shipping_rates.json?" + params)
                .then(function(r) { return r.json(); })
                .then(function(data) {
                    log(data);
                    freteLista.innerHTML = "";
                    if (data.shipping_rates && data.shipping_rates.length) {
                        var jadlogKey = "Jadlog";
                        var freteFixoKey = "Frete Fixo";
                        var jadlogEntrega = null;
                        for (var j = 0; j < data.shipping_rates.length; j++) {
                            var r = data.shipping_rates[j];
                            if (r.name && r.name.indexOf(jadlogKey) !== -1 && r.name.indexOf(freteFixoKey) === -1) {
                                if (r.delivery_days && r.delivery_days[r.delivery_days.length - 1] != null) {
                                    jadlogEntrega = "Até " + r.delivery_days[r.delivery_days.length - 1] + " dias úteis";
                                } else if (r.delivery_date) {
                                    var jDate = new Date(r.delivery_date);
                                    var jToday = new Date();
                                    var jDiff = Math.ceil(Math.abs(jDate - jToday) / (1000 * 60 * 60 * 24));
                                    jadlogEntrega = "Até " + jDiff + " dias úteis";
                                }
                                break;
                            }
                        }
                        for (var i = 0; i < data.shipping_rates.length; i++) {
                            var rate = data.shipping_rates[i];
                            var entrega = "Estimativa de entrega indisponível";
                            if (rate.delivery_days && rate.delivery_days[rate.delivery_days.length - 1] != null) {
                                entrega = "Até " + rate.delivery_days[rate.delivery_days.length - 1] + " dias úteis";
                            } else if (rate.delivery_date) {
                                var deliveryDate = new Date(rate.delivery_date);
                                var today = new Date();
                                var diffDays = Math.ceil(Math.abs(deliveryDate - today) / (1000 * 60 * 60 * 24));
                                entrega = "Até " + diffDays + " dias úteis";
                            } else if (jadlogEntrega) {
                                entrega = jadlogEntrega;
                            }
                            var valorFrete = rate.price;
                            if (valorFrete == "0.00" || valorFrete == null || valorFrete == 0 || valorFrete === "0") {
                                valorFrete = "Grátis";
                            } else {
                                valorFrete = "R$ " + parseFloat(valorFrete).toFixed(2).replace(".", ",");
                            }
                            var freteItem = document.createElement("div");
                            freteItem.className = "frete-item";
                            freteItem.innerHTML = "<div><p class=\"m-0 nome-frete\"><b>" + rate.name + "</b><span class=\"estimativa-de-entrega\">" + entrega + "</span></p></div><div class=\"frete-valor\">Valor: <b>" + valorFrete + "</b></div>";
                            freteLista.appendChild(freteItem);
                        }
                    } else {
                        freteLista.innerHTML = "<p>Não encontramos fretes disponíveis para este CEP.</p>";
                    }
                })
                .catch(function(error) { log(error); showError("Erro ao calcular frete. Tente novamente."); });
            })
            .catch(function(error) { showError("Erro ao validar CEP. Tente novamente."); log(error); });
    };

    // Lazy init: inicializa apenas no primeiro clique do toggle
    document.addEventListener("click", function(e) {
        if (e.target.closest("#miniCartShippingToggle")) {
            initFields();
        }
    });

})();
